export default __webpack_public_path__ + "static/media/advance_crown.bae2a52d.svg";